import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

// One box per OTP digit: typing moves to the next box, Backspace on an empty
// box goes back, and a pasted code fills them all. `value` is the code so far.
const OtpBoxes = ({ length = 4, value, onChange, autoFocus = true }) => {
    const { t } = useTranslation();
    const refs = useRef([]);
    const digits = Array.from({ length }, (_, i) => value[i] || "");

    useEffect(() => {
        if (autoFocus) refs.current[0]?.focus();
    }, [autoFocus]);

    const setDigit = (i, digit) => {
        const next = digits.slice();
        next[i] = digit;
        onChange(next.join("").slice(0, length));
    };

    const handleInput = (i) => (e) => {
        const digit = e.target.value.replace(/\D/g, "").slice(-1);
        setDigit(i, digit);
        if (digit && refs.current[i + 1]) refs.current[i + 1].focus();
    };

    const handleKeyDown = (i) => (e) => {
        if (e.key === "Backspace" && !digits[i] && refs.current[i - 1]) refs.current[i - 1].focus();
    };

    const handlePaste = (e) => {
        const pasted = (e.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, length);
        if (!pasted) return;
        e.preventDefault();
        onChange(pasted);
        (refs.current[pasted.length] || refs.current[length - 1]).focus();
    };

    return (
        <div className="otpbox" onPaste={handlePaste}>
            {digits.map((digit, i) => (
                <input
                    key={i}
                    ref={(el) => { refs.current[i] = el; }}
                    inputMode="numeric"
                    autoComplete={i === 0 ? "one-time-code" : "off"}
                    maxLength={1}
                    aria-label={t("auth.digit", { n: i + 1 })}
                    value={digit}
                    onChange={handleInput(i)}
                    onKeyDown={handleKeyDown(i)}
                />
            ))}
        </div>
    );
};

export default OtpBoxes;
